// eslint-disable-next-line import/prefer-default-export
export const BER_MAP: { [key: string]: string } = {
  A: '#02a64f',
  A0: '#389BD0',
  A1: '#02a64f',
  A2: '#02a64f',
  A3: '#02a64f',
  B: '#52b447',
  B1: '#52b447',
  B2: '#52b447',
  B3: '#52b447',
  C: '#bed434',
  C1: '#bed434',
  C2: '#bed434',
  C3: '#bed434',
  D: '#fced1e',
  D1: '#fced1e',
  D2: '#fced1e',
  E: '#fbb716',
  E1: '#fbb716',
  E2: '#fbb716',
  F: '#f37022',
  G: '#e72327',
};
